import { forwardRef, ReactElement } from 'react';
import { Chip, ChipProps } from '@mui/material';

import { Icon, IconOption } from '@components/base';
import { isIconOption } from '@components/base/dataDisplay/Icon/iconOptions';

import useMenu from './useMenu';

export type MenuChipButtonProps = Omit<ChipProps, 'deleteIcon' | 'icon' | 'onDelete'> & {
  hideExpandIcon?: boolean;
  icon?: IconOption | ReactElement;
};

export const MenuChipButton = forwardRef<HTMLDivElement, MenuChipButtonProps>(
  ({ hideExpandIcon, icon, onClick, ...rest }, ref) => {
    const { onOpen } = useMenu();

    return (
      <Chip
        deleteIcon={hideExpandIcon ? undefined : <Icon name='expandMore' />}
        icon={icon ? isIconOption(icon) ? <Icon name={icon} /> : icon : undefined}
        onClick={e => {
          onClick?.(e);
          onOpen(e);
        }}
        onDelete={
          hideExpandIcon
            ? undefined
            : e => {
                onClick?.(e);
                onOpen(e);
              }
        }
        ref={ref}
        {...rest}
      />
    );
  }
);
